// extracted by mini-css-extract-plugin
export default {"container":"channelAvatar_container__Ba4dF","nameBox":"channelAvatar_nameBox__w07eo","channelName":"channelAvatar_channelName__EFIFd","avatar":"channelAvatar_avatar__8MsJy"};